import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API } from '../config/api';
import LoadingSpinner from '../components/LoadingSpinner';

const NewsPage = () => {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchNews = async () => {
      try {
        const response = await axios.get(`${API}/news?limit=20`);
        setNews(response.data);
      } catch (error) {
        console.error('Error fetching news:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchNews();
  }, []);

  if (loading) return <LoadingSpinner />;

  return (
    <div className="section">
      <div className="container-custom">
        <div className="mb-12">
          <h1 className="font-display text-5xl mb-4">Notizie</h1>
          <p className="text-[#64748b] text-lg">Aggiornamenti dal mondo Equus Prime</p>
        </div>

        {news.length === 0 ? (
          <div className="text-center py-20">
            <p className="text-[#64748b] text-lg">Nessuna notizia disponibile</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {news.map(item => (
              <a key={item.news_id} href={`/notizia/${item.news_id}`} className="group">
                {item.image_url && (
                  <div className="overflow-hidden mb-4">
                    <img 
                      src={item.image_url} 
                      alt={item.title}
                      className="w-full h-48 object-cover transition-transform duration-500 group-hover:scale-105"
                    />
                  </div>
                )}
                <p className="text-[#64748b] text-sm mb-2">
                  {new Date(item.created_at).toLocaleDateString('it-IT', { 
                    day: 'numeric', 
                    month: 'long', 
                    year: 'numeric' 
                  })}
                </p>
                <h3 className="font-display text-xl group-hover:text-[#c9a227] transition-colors">
                  {item.title}
                </h3>
                <p className="text-[#64748b] mt-2 line-clamp-2">{item.excerpt}</p>
              </a>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};


export default NewsPage;
